var map = {
	"./imac-pro.svg": "652c",
	"./imac.svg": "37fa",
	"./mac-mini.svg": "c1ad",
	"./mac-pro.svg": "fa74",
	"./macbook-air.svg": "02b8",
	"./macbook-pro.svg": "08dd"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "46fc";